
angular.module('app.directives', [
  'app.directives.slide_box',
  'app.directives.static_popover',
  'app.directives.right_side_nav',
  'app.directives.json_text',
  'app.directives.forms.dynamic_id',
  'app.directives.forms.std_controls',
  'app.directives.forms.pattern_model',
  'app.directives.accordion',
  'app.directives.tab_select',
  'app.directives.link_highlight'
]);
